import ListModule from '../list-module'
import ListState from '../list-state'
import Manufacturer from '../../entities/admin/manufacturer'
import Util from '../../../lib/util'

interface ManufacturerState extends ListState<Manufacturer> {
    editModel: Manufacturer;
}
class ManufacturerModule extends ListModule<ManufacturerState, any, Manufacturer> {
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<Manufacturer>(),
        loading: false,
        editModel: new Manufacturer(),
        activeList: new Array<Manufacturer>(),
        path: 'manufacturers'
    }
    actions = Util.extend(true, this.base_actions, {
        //extra actions
    });
    mutations = Util.extend(true, this.base_mutations, {
        //extra mutations
    });
}
const manufacturerModule = new ManufacturerModule();
export default manufacturerModule;